export default "<div id='main-ctnr'>\n    <app-filtered-by-thematics></app-filtered-by-thematics>\n</div>\n"